<ng-container *transloco="let t; read: 'configurations.content-form'">
  <h3>{{ t('what-to-import') }}</h3>

  <mat-checkbox
    [checked]="allConfigItems.include"
    [indeterminate]="allConfigItems.indeterminate"
    [disabled]="!!allConfigItems.disable"
    [matTooltip]="allConfigItems.tooltip"
    (input)="toggleAllItems()"
    >{{ t('all-items') }}</mat-checkbox
  >

  @for (item of configItems; track item) {
    <div class="configuration-content-form__include-column">
      <mat-checkbox
        [checked]="item.include"
        [indeterminate]="item.indeterminate"
        [disabled]="!!item.disable"
        (input)="toggleConfigItem(item)"
        >{{ t(item.prop) }} &nbsp; ({{ item.count }})</mat-checkbox
      >
      @if (item.tooltip) {
        <div [matTooltip]="item.tooltip">
          <xi-icon icon="warning" color="error"></xi-icon>
        </div>
      }
    </div>
  }

  <h3>{{ t('include-details') }}</h3>

  <div>
    <mat-checkbox [checked]="includeNotes" (input)="toggleNotes()">{{
      t('description')
    }}</mat-checkbox>
  </div>

  <div>
    <mat-checkbox [checked]="includeTags" (input)="toggleTags()">{{ t('tags') }}</mat-checkbox>
  </div>
</ng-container>
